export enum ELetterErrorMessages {
  Max = 'Текст не может быть длиннее 100 символов',
  Required = 'Введите корректное значение',
}
